/* Why Sunday as a story (mockup v95): flip cards (the whole card turns), "more" on a phone, the film,
   the reveal as you scroll, the count-up, and the dock stepping away while the founder's note is on screen. */
(() => {
  const root = document.querySelector('[data-sw]');
  if (!root) return;

  root.addEventListener('click', (e) => {
    const t = e.target;
    if (!t.closest) return;
    const card = !t.closest('.sw-fsrc a') && t.closest('.sw-fl');
    if (card) {
      const c = card.closest('.sw-fc');
      const on = !c.classList.contains('on');
      c.classList.toggle('on', on);
      const fr = c.querySelector('.sw-ff');
      const bk = c.querySelector('.sw-fb');
      fr.setAttribute('aria-expanded', on);
      fr.tabIndex = on ? -1 : 0;
      bk.setAttribute('aria-hidden', !on);
      bk.querySelectorAll('a,button').forEach((x) => { x.tabIndex = on ? 0 : -1; });
      (on ? bk.querySelector('.sw-bk') : fr).focus({ preventScroll: true });
      return;
    }
    const m = t.closest('[data-sw-more]');
    if (m) {
      const g = root.querySelector('[data-sw-more-list]');
      const on = !g.classList.contains('all');
      g.classList.toggle('all', on);
      m.setAttribute('aria-expanded', on);
      m.textContent = on ? m.dataset.fewer : m.dataset.more;
      return;
    }
    const d = root.querySelector('#sw-dlg');
    if (t.closest('[data-sw-film]') && d && d.showModal) {
      d.showModal();
      const v = d.querySelector('video');
      if (v) v.play().catch(() => {});
      return;
    }
    if (t.closest('[data-sw-close]') && d) d.close();
  });
  const dlg = root.querySelector('#sw-dlg');
  if (dlg) dlg.addEventListener('close', () => { const v = dlg.querySelector('video'); if (v) v.pause(); });

  /* the first prototypes rail starts at the chosen photo (block setting), where it scrolls sideways */
  const rail = root.querySelector('.sw-col[data-sw-start]');
  if (rail) {
    const n = parseInt(rail.dataset.swStart, 10) || 1;
    const kids = rail.children;
    if (n > 1 && kids[n - 1] && rail.scrollWidth > rail.clientWidth + 2) {
      rail.scrollLeft = kids[n - 1].offsetLeft - kids[0].offsetLeft;
    }
  }

  /* one end action: the dock steps away while the note's button is on screen */
  const note = root.querySelector('[data-sw-note]');
  if (note && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => document.body.classList.toggle('sd-sw-endv', en.isIntersecting), { threshold: 0.25 }).observe(note);
  }

  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.webdriver;
  if (calm || !('IntersectionObserver' in window)) return;
  const items = [...root.querySelectorAll('.sw-oc .sw-pr,.sw-big,.sw-cb > :not(.sw-col):not(.sw-big),.sw-tdl > *,.sw-fc,.sw-oq,.sw-lt,.sw-nw,.sw-ff2 li')];
  const vh = innerHeight;
  items.forEach((el) => { if (el.getBoundingClientRect().top > vh) el.classList.add('sw-pre'); });
  const count = (b) => {
    const end = +b.dataset.swN;
    if (!end || b.dataset.done) return;
    b.dataset.done = '1';
    const t0 = performance.now();
    const step = (n) => {
      const k = Math.min(1, (n - t0) / 900);
      b.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))).toLocaleString('en-IN');
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver((es) => es.forEach((en) => {
    if (!en.isIntersecting) return;
    const el = en.target;
    el.classList.add('sw-in');
    el.classList.remove('sw-pre');
    el.querySelectorAll('[data-sw-n]').forEach(count);
    io.unobserve(el);
  }), { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  items.forEach((el) => io.observe(el));
})();
